<app-banner>
    <form class="public-page-forms" [formGroup]="registrationForm" (ngSubmit)="onSubmit()">
        <h1 class="form-title" i18n="@@register.title">Registreren</h1>
        <div class="input-container">
            <label for="inputEmail" i18n="@@register.email">E-mailadres*</label>
            <input id="inputEmail" type="email" formControlName="email" class="input" required />
            @if (registrationForm.controls.email.touched && registrationForm.controls.email.errors?.email) {
                <div class="error-text" i18n="@@error.email">Dit is geen geldig e-mailadres.</div>
            }
            @if (registrationForm.controls.email.touched && registrationForm.controls.email.errors?.required) {
                <div class="error-text" i18n="@@error.required">Dit veld is verplicht.</div>
            }
            @if (registrationForm.controls.email.touched && registrationForm.controls.email.errors?.backend) {
                <div class="error-text">{{ registrationForm.controls.email.errors?.backend }}</div>
            }
        </div>
        <div class="input-container">
            <label for="inputFirstName" i18n="@@register.firstname" required>Voornaam*</label>
            <input id="inputFirstName" type="firstName" formControlName="firstName" class="input" />
            @if (registrationForm.controls.firstName.touched && registrationForm.controls.firstName.errors?.required) {
                <div class="error-text" i18n="@@error.required">Dit veld is verplicht.</div>
            }
        </div>
        <div class="input-container">
            <label for="inputLastName" i18n="@@register.lastName" required>Familienaam*</label>
            <input id="inputLastName" type="lastName" formControlName="lastName" class="input" />
        </div>
        @if (registrationForm.controls.lastName.touched && registrationForm.controls.lastName.errors?.required) {
            <div class="error-text" i18n="@@error.required">Dit veld is verplicht.</div>
        }
        <div class="input-container">
            <label for="inputPassword1" class="text-input-label" i18n="@@register.password">Wachtwoord*</label>
            <input id="inputPassword1" type="password" formControlName="password1" class="input" required />
            @if (registrationForm.controls.password1.touched && registrationForm.controls.password1.errors?.required) {
                <div class="error-text" i18n="@@error.required">Dit veld is verplicht.</div>
            }
            @if (registrationForm.controls.password1.touched && registrationForm.controls.password1.errors?.minlength) {
                <div class="error-text" i18n="@@register.error.minlength"
                    >Het wachtwoord moet minstens {{ minPasswordLength }} tekens lang zijn</div
                >
            }
            @if (
                registrationForm.controls.password1.touched &&
                registrationForm.controls.password1.errors?.passwordStrength?.hasUpperCase === false
            ) {
                <div s class="error-text" i18n="@@register.error.hasUpperCase">Het wachtwoord moet hoofdletters bevatten</div>
            }
            @if (
                registrationForm.controls.password1.touched &&
                registrationForm.controls.password1.errors?.passwordStrength?.hasLowerCase === false
            ) {
                <div s class="error-text" i18n="@@register.error.hasLowerCase">Het wachtwoord moet kleine letters bevatten</div>
            }
            @if (
                registrationForm.controls.password1.touched &&
                registrationForm.controls.password1.errors?.passwordStrength?.hasNumeric === false
            ) {
                <div s class="error-text" i18n="@@register.error.hasNumeric">Het wachtwoord moet cijfers bevatten</div>
            }
            @if (
                registrationForm.controls.password1.touched &&
                registrationForm.controls.password1.errors?.passwordStrength?.hasSpecial === false
            ) {
                <div s class="error-text" i18n="@@register.error.hasSpecial"
                    >Het wachtwoord moet bijzondere tekens bevatten ({{ specialCharacters | join: ', ' }})</div
                >
            }
        </div>
        <div class="input-container">
            <label for="inputPassword2" i18n="@@form.passwordVerification">Wachtwoord opnieuw invoeren*</label>
            <input id="inputPassword2" type="password" formControlName="password2" class="input" required />
            @if (registrationForm.controls.password2.touched && registrationForm.errors?.notEqual) {
                <div class="error-text" i18n="@@register.error.passwordVerification">Wachtwoorden komen niet overeen.</div>
            }
            @if (registrationForm.controls.password2.touched && registrationForm.controls.password2.errors?.required) {
                <div class="error-text" i18n="@@error.required">Dit veld is verplicht.</div>
            }
        </div>
        <div class="button-row">
            <button type="submit" class="button-primary huge w-full" [disabled]="busy">
                @if (!busy) {
                    <ng-container i18n="@@register">Registreer</ng-container>
                } @else {
                    <fa-icon class="me-2" [icon]="loadingIcon" [animation]="'spin'" />
                    <ng-container><span i18n="@@register.loading">Bezig met registreren…</span></ng-container>
                }
            </button>
        </div>

        <div class="relative flex items-center px-2 py-5">
            <div class="flex-grow border-t-2 border-gray-400"></div>
            <span class="mx-4 flex-shrink uppercase text-body" i18n="@@choice.or">of</span>
            <div class="flex-grow border-t-2 border-gray-400"></div>
        </div>

        <div class="button-row">
            <a type="button" class="button-silverfin huge w-full hover:no-underline" [href]="silverfinLogin">
                <img class="-my-1 h-10" src="/assets/icons/silverfin.png" />
                <span i18n="@@login.loginSilverfin">Meld aan met Silverfin</span>
            </a>
        </div>

        <a class="primary-link font-bold" routerLink="/login" i18n="@@login.link">Log in</a>
        <a class="body-link" routerLink="/reset-password" i18n="@@login.forgotPassword">Wachtwoord vergeten</a>
        <a class="body-link" href="#" i18n="@@verificationMail.linkAgain">Stuur verificatiemail opnieuw</a>
    </form>
</app-banner>

<ng-template #loading>
    <fa-icon class="me-2" [icon]="loadingIcon" [animation]="'spin'" />
    <ng-container><span i18n="@@register.loading">Bezig met registreren…</span></ng-container>
</ng-template>
